import styles from './Code.module.scss'
import { CodeProps } from './Code.types'
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter'
import { Copy } from '@percent/lemonade'

export function Code({ code, language, lineNumbers = false, wordWrap = false, onCopy, dataTestId }: CodeProps) {
  const handleCopy = () => {
    if (onCopy) {
      onCopy()
    }
  }

  return (
    <div className={styles.wrapper} data-testid={dataTestId}>
      <SyntaxHighlighter
        customStyle={{
          backgroundColor: '#F8F6F2',
          borderRadius: '8px',
          fontSize: '14px',
          padding: '24px',
          paddingRight: '48px',
          margin: 0
        }}
        language={language}
        showInlineLineNumbers={lineNumbers}
        wrapLongLines={wordWrap}
      >
        {code}
      </SyntaxHighlighter>
      <div
        role="button"
        tabIndex={0}
        onClick={handleCopy}
        onKeyDown={e => {
          if (e.key === 'Enter') {
            e.preventDefault()
            handleCopy()
          }
        }}
      >
        <Copy text={code} className={styles.copy} />
      </div>
    </div>
  )
}
